export default __webpack_public_path__ + "static/media/pitic-logo.5963cd0e.jpg";